import React from "react";
import "./style.scss";

const Loader = () => {
  return (
    <div className="loader-modal">
      <div className="loader-modal__loadingbox">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  );
};

export default Loader;
